import { useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import LookupModal from "components/common/LookupModal";
import DTextField from "components/common/DTextField";

export default function LookupField({
    resource,
    value,
    onChange,
    label,
    required,
    displayField = "name",
    valueField = "id",
    error,
    filterValues
}) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <DTextField
                fullWidth
                variant="outlined"
                label={label}
                value={value ? value : ""}
                required={required}
                error={Boolean(error)}
                helperText={error || ""}
                sx={{
                    marginBottom: "unset",
                    marginTop: "unset",
                    margin: "4px"
                }}
                slotProps={{
                    input: {
                        readOnly: true,
                        onClick: () => setIsOpen(true),
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setIsOpen(true)}
                                    aria-label={`Select ${label}`}
                                    edge="end"
                                >
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        )
                    }
                }}
            />

            {isOpen && (
                <LookupModal
                    resource={resource}
                    displayField={displayField}
                    valueField={valueField}
                    filterValues={filterValues}
                    onSelect={(item) => {
                        onChange(item);
                        setIsOpen(false);
                    }}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
}
